<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            sort-by="calories"
            class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Müşteriler</v-toolbar-title>
                <v-divider
                        class="mx-4"
                        inset
                        vertical
                ></v-divider>
                 <v-text-field
                    v-model="search"
                    append-icon="mdi-search"
                    label="Ara"
                    single-line
                    hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2" v-on="on">Ekle</v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="12">
                                        <v-text-field v-model="editedItem.musteriid" label="ID" disabled="disabled"></v-text-field>
                                        <v-text-field v-model="editedItem.musteriadisoyadi" label="Ad Soyad"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="12">
                                        <v-text-field v-model="editedItem.username" label="Kullanıcı Adı"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="12">
                                        <v-text-field v-model="editedItem.password" label="Şifre"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
            <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon v-if="1 == 0"
                    small
                    @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
        </template>
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reload</v-btn>
        </template>
    </v-data-table>
</template>

<script>
    import { loadProgressBar } from 'axios-progress-bar'
    export default {
        data: () => ({
            search:"",
            dialog: false,
            headers: [
                { text: 'ID', value: 'musteriid' },
                { text: 'Ad soyad', value: 'musteriadisoyadi' },
                { text: 'Kullanıcı adı', value: 'username' },
                { text: 'Şifre', value: 'password' },
                { text: 'Düzenle', value: 'action', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            file:new Blob([]),
            editedItem: {
                musteriid:'',
                musteriadisoyadi: '',
                username: '',
                password: '',
            },
            defaultItem: {
                musteriid:'',
                musteriadisoyadi: '',
                username: '',
                password: '',
            },
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },

        created () {
            this.initialize()
        },

        methods: {
            initialize () {
                loadProgressBar(this.axios.config,this.axios);
                this.$axios.get("accounts").then(response=>{
                     this.items = response.data;
                });
                //this.items = []
            },

            editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                console.log("item",item);
                const index = this.items.indexOf(item);
                let cnf = confirm('Are you sure you want to delete this item?')
                if(cnf){
                    let formData = new FormData();
                    formData.append('id',item.id);
                    loadProgressBar(this.axios.config,this.axios);
                    this.$axios.post("admin/audio_delete",formData).then(d=>{
                        //alert(d.data.message);
                        this.items.splice(index, 1)
                    },err=>{
                        console.log("err",err);
                        alert(err.message);
                        return false;
                        //this.setFileZero();
                    });
                }
            },

            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },
            setFileZero(){
              this.file = new Blob([]);
                this.$refs.file.files = null;
                this.$refs.file.value = "";

            },
            async insert(){
                //console.log(this.file);
                this.$axios.post("account",formData).then(d=>{
                    console.log(d);
                    //alert(d.data.message);
                    this.items.push(this.editedItem);
                    return true;
                },err=>{
                    alert(err.message);
                    this.setFileZero();
                    return false;
                })
            },
            async update(){
                let requestData = {
                    userName : this.editedItem.username,
                    password : this.editedItem.password,
                    musteriId : this.editedItem.musteriid
                }
                this.$axios.post("updateAccount",requestData).then(d=>{
                    console.log("then",d);
                    //alert(d.data.message);
                    Object.assign(this.items[this.editedIndex], this.editedItem);
                    return true;
                },err=>{
                    console.log("err",err);
                    alert(err.message);
                    return false;
                });

            },
            async delete(){

            },
            async save () {
                if (this.editedIndex > -1) {
                    let isUpdated = await this.update();
                    console.log("isUpdated",isUpdated);
                } else {
                    let isInserted = await this.insert();
                    console.log("isInserted",isInserted);
                }
                this.close()
            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
            }
        },
    }
</script>

<script11>



    export default {
        name: "dashboard",
        mounted() {
            this.$axios.get("audios").then(response=>{
                // this.items = response.data;
            })
        },
        methods: {
            showAlert(a){
                alert('Alert!');
            }
        },
        data: () => ({
                selected:[],
                search: '',
                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                    },
                    { text: 'Title', value: 'title' },
                    { text: 'Short text' , value: 'short_description' },
                    { text: 'Edit'  },

                ],
                items: [{
                    id:1,
                    title:"asds",
                    short_description:"",
                    hash:"213"
                }, {
                    id: 2,
                    title: "asds2",
                    short_description: "",
                    hash: "213"
                }]

        })

    }
</script11>

<style scoped>

</style>
